import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const apiUrlTipos = `${(process.env.REACT_APP_API_PLATOS || 'http://localhost:8085/api/platos/').replace(/\/+$/, '')}/../tipos-plato`;

const CrearTipoPlato = () => {
    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [activo, setActivo] = useState(true);
    const navigate = useNavigate();

    const store = async (e) => {
        e.preventDefault();

        if (nombre.trim() === '') {
            alert('El nombre es requerido');
            return;
        }

        try {
            await axios.post(apiUrlTipos, {
                nombre: nombre.trim(),
                descripcion: descripcion.trim() || null,
                activo
            });
            alert('Tipo de plato creado correctamente');
            navigate('/admin/tipos-plato');
        } catch (error) {
            console.error('Error al crear tipo de plato:', error);
            if (error.response?.data?.message) {
                alert(error.response.data.message);
            } else {
                alert('Error al crear el tipo de plato');
            }
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 py-8 px-4">
            <div className="max-w-2xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-t-2xl shadow-xl p-6 border-b-4 border-indigo-500">
                    <div className="flex items-center gap-4">
                        <div className="bg-gradient-to-br from-indigo-500 to-purple-600 p-4 rounded-xl shadow-lg">
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold text-gray-800">Crear Tipo de Plato</h1>
                            <p className="text-gray-600 mt-1">Define una nueva categoría para tus platos</p>
                        </div>
                    </div>
                </div>

                {/* Form */}
                <form onSubmit={store} className="bg-white rounded-b-2xl shadow-xl p-8">
                    <div className="space-y-6">
                        {/* Nombre */}
                        <div>
                            <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-indigo-600">🏷️</span>
                                Nombre del Tipo
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                placeholder="Ej: General, Veggie, Pechuga, Celiaco, etc."
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-all outline-none text-gray-800 placeholder-gray-400"
                                required
                            />
                        </div>

                        {/* Descripción */}
                        <div>
                            <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-purple-600">📝</span>
                                Descripción (opcional)
                            </label>
                            <textarea
                                placeholder="Describe brevemente este tipo de plato..."
                                value={descripcion}
                                onChange={(e) => setDescripcion(e.target.value)}
                                rows="3"
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-100 transition-all outline-none text-gray-800 placeholder-gray-400 resize-none"
                            />
                        </div>

                        {/* Activo */}
                        <div>
                            <label className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg border-2 border-gray-200 cursor-pointer hover:bg-gray-100 transition-all">
                                <input
                                    type="checkbox"
                                    checked={activo}
                                    onChange={(e) => setActivo(e.target.checked)}
                                    className="w-5 h-5 text-indigo-600 rounded focus:ring-2 focus:ring-indigo-500"
                                />
                                <div className="flex-1">
                                    <span className="font-semibold text-gray-700">Tipo activo</span>
                                    <p className="text-sm text-gray-500">Solo los tipos activos aparecerán al crear platos</p>
                                </div>
                            </label>
                        </div>
                    </div>

                    {/* Botones */}
                    <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t-2 border-gray-200">
                        <button
                            type="submit"
                            className="flex-1 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:from-indigo-700 hover:to-purple-700 transform hover:scale-[1.02] transition-all"
                        >
                            <span className="flex items-center justify-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                                Crear Tipo
                            </span>
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate('/admin/tipos-plato')}
                            className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-3 px-6 rounded-lg shadow-md transform hover:scale-[1.02] transition-all"
                        >
                            <span className="flex items-center justify-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                Cancelar
                            </span>
                        </button>
                    </div>
                </form>

                {/* Info footer */}
                <div className="mt-6 bg-white border border-gray-100 rounded-xl p-6 shadow-lg">
                    <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2">
                        <span className="text-yellow-500">💡</span>
                        Ejemplos recomendados:
                    </h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <div className="p-3 bg-indigo-50 rounded-lg border border-indigo-100">
                            <span className="font-bold text-indigo-700 block text-xs uppercase tracking-wider mb-1">Tradicional</span>
                            <span className="text-sm text-indigo-900 font-semibold">General / Menú Diario</span>
                        </div>
                        <div className="p-3 bg-green-50 rounded-lg border border-green-100">
                            <span className="font-bold text-green-700 block text-xs uppercase tracking-wider mb-1">Vegetal</span>
                            <span className="text-sm text-green-900 font-semibold">Veggie / Vegetariano</span>
                        </div>
                        <div className="p-3 bg-orange-50 rounded-lg border border-orange-100">
                            <span className="font-bold text-orange-700 block text-xs uppercase tracking-wider mb-1">Proteico</span>
                            <span className="text-sm text-orange-900 font-semibold">Pechuga con Guarnición</span>
                        </div>
                        <div className="p-3 bg-rose-50 rounded-lg border border-rose-100">
                            <span className="font-bold text-rose-700 block text-xs uppercase tracking-wider mb-1">Salmón</span>
                            <span className="text-sm text-rose-900 font-semibold">Celiaco / Sin TACC</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CrearTipoPlato;
